module.exports = __webpack_public_path__ + "6dba906651aba7bc5b00330721dc7c3e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/cross.svg
// module id = 476
// module chunks = 0